module.exports = __webpack_public_path__ + "resources/img/img_watchall_nms1_m_en.508fc62a39a3b95d8a06c25c028aad8c.png";